import init_components from './components';
import init_form_fix from './form-fix';
import init_params_pass from './params_pass';
import init_tracking from './tracking';
export default function initJS({ appIdentifier, siteLevel2 } = {}) {
  init_tracking({ appIdentifier, siteLevel2 });

  init_components();
  init_form_fix();
  init_params_pass();
}
